import React, { useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import { Typography } from "@mui/material";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import useToast from '../../../helpers/useToast';
import useEncryption from '../../../services/useEncryption';
import useHeaders from '../../../helpers/useHeaders';
import { useSelector } from 'react-redux';
import { selectAuth } from '../../../redux/slice/authSlice';
import { createAuditLogs } from '../../../api/providerApi/providerApi';
import { addCustomQuestion, updateCustomQuestion } from '../../../api/typeFormQuestionApi';


const AdminQuestionModal = ({ open, handleClose, setUpdate, data }) => {
  const toastOption = useToast();
  const { role } = useSelector(selectAuth);
  const headers = useHeaders();
  const { encryptData } = useEncryption();

  // Validation schema
  const questionSchema = Yup.object({
    questionVariable: Yup.string()
      .trim()
      .required("Question Variable is required"),

    customVariable: Yup.string()
      .trim()
      .required("Custom Variable is required"),
  });


  const formik = useFormik({
    initialValues: {
      questionVariable: data?.questionVariable || "",
      customVariable: data?.customVariable || "",
    },
    validationSchema: questionSchema,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      try {
        let response;

        if (data) {
          // EDIT MODE
          response = await updateCustomQuestion(data._id, values);

        //   let log = {
        //     event: `${role} updated question ${values.questionVariable}.`
        //   };
        //   await createAuditLogs({ data: encryptData(log) }, headers);

        } else {
          // ADD MODE
          response = await addCustomQuestion(values);

        //   let log = {
        //     event: `${role} added new question ${values.questionVariable}.`
        //   };
        //   await createAuditLogs({ data: encryptData(log) }, headers);
        }

        toast.success(response.data.message || "Success!", toastOption);

        resetForm();
        setUpdate(prev => !prev);
        handleClose();

      } catch (err) {
        toast.error(
          err?.response?.data?.message || "An error occurred.",
          toastOption
        );
      }
    },
  });




  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="question-modal"
      open={open}
    >
      <div className="d-flex align-items-center justify-content-between">
        <DialogTitle id="question-modal">
          {data ? "Edit Question" : "Add Question"}
        </DialogTitle>

        <IconButton aria-label="close" onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </div>

      <DialogContent dividers>
        <form className="sectionalForms">

          <div className="row">
            
            {/* Question Variable */}
            <div className="col-lg-12 col-sm-12">
              <div className="formdesign">
                <TextField
                  label="Question Variable"
                  className="w-100"
                  variant="outlined"
                  size="small"
                  name="questionVariable"
                  value={formik.values.questionVariable}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.questionVariable && Boolean(formik.errors.questionVariable)}
                  helperText={formik.touched.questionVariable && formik.errors.questionVariable}
                />
              </div>
            </div>

            {/* Custom Variable */}
            <div className="col-lg-12 col-sm-12">
              <div className="formdesign">
                <TextField
                  label="Custom Variable"
                  className="w-100"
                  variant="outlined"
                  size="small"
                  name="customVariable"
                  value={formik.values.customVariable}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.customVariable && Boolean(formik.errors.customVariable)}
                  helperText={formik.touched.customVariable && formik.errors.customVariable}
                />
              </div>
            </div>

          </div>

        </form>
      </DialogContent>

      <DialogActions>
        <div className="text-end modalactions">
          <button className="btn btn-blacked outline me-2" onClick={handleClose}>
            Cancel
          </button>

          <button className="btn btn-blacked" onClick={formik.handleSubmit}>
            {data ? "Update" : "Submit"}
          </button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default AdminQuestionModal;